import { render, staticRenderFns } from "./noticeDetails.vue?vue&type=template&id=490353c2&scoped=true&"
import script from "./noticeDetails.vue?vue&type=script&lang=js&"
export * from "./noticeDetails.vue?vue&type=script&lang=js&"
import style0 from "./noticeDetails.vue?vue&type=style&index=0&id=490353c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490353c2",
  null
  
)

export default component.exports